export interface FormFieldsTranslations {
  name: string;
  email: string;
  message: string;
  namePlaceholder: string;
  emailPlaceholder: string;
  messagePlaceholder: string;
}

export interface FormActionsTranslations {
  cancel: string;
  send: string;
  sending: string;
}

export interface ErrorTranslations {
  invalidName: {
    title: string;
    description: string;
  };
  invalidEmail: {
    title: string;
    description: string;
  };
  generic: {
    title: string;
    description: string;
  };
}

export interface SuccessTranslations {
  title: string;
  description: string;
}

export interface Translations {
  name: string;
  email: string;
  message: string;
  cancel: string;
  send: string;
  sending: string;
  namePlaceholder: string;
  emailPlaceholder: string;
  messagePlaceholder: string;
  success: SuccessTranslations;
  error: ErrorTranslations;
}

export const translations: Record<string, Translations> = {
  en: {
    name: "Name",
    email: "Email",
    message: "Message (optional)",
    cancel: "Cancel",
    send: "Send",
    sending: "Sending...",
    namePlaceholder: "Enter your name",
    emailPlaceholder: "Enter your email",
    messagePlaceholder: "Leave us a message...",
    success: {
      title: "Success!",
      description: "Thank you for your interest. We'll be in touch soon!"
    },
    error: {
      invalidName: {
        title: "Invalid Name",
        description: "Please enter a valid name (2-50 characters, letters and spaces only)"
      },
      invalidEmail: {
        title: "Invalid Email",
        description: "Please enter a valid email address"
      },
      generic: {
        title: "Error",
        description: "Something went wrong. Please try again."
      }
    }
  },
  es: {
    name: "Nombre",
    email: "Correo electrónico",
    message: "Mensaje (opcional)",
    cancel: "Cancelar",
    send: "Enviar",
    sending: "Enviando...",
    namePlaceholder: "Introduce tu nombre",
    emailPlaceholder: "Introduce tu correo electrónico",
    messagePlaceholder: "Déjanos un mensaje...",
    success: {
      title: "¡Éxito!",
      description: "Gracias por tu interés. ¡Nos pondremos en contacto pronto!"
    },
    error: {
      invalidName: {
        title: "Nombre Inválido",
        description: "Por favor, introduce un nombre válido (2-50 caracteres, solo letras y espacios)"
      },
      invalidEmail: {
        title: "Correo Electrónico Inválido",
        description: "Por favor, introduce una dirección de correo electrónico válida"
      },
      generic: {
        title: "Error",
        description: "Algo salió mal. Por favor, inténtalo de nuevo."
      }
    }
  },
  ca: {
    name: "Nom",
    email: "Correu electrònic",
    message: "Missatge (opcional)",
    cancel: "Cancel·lar",
    send: "Enviar",
    sending: "Enviant...",
    namePlaceholder: "Introdueix el teu nom",
    emailPlaceholder: "Introdueix el teu correu electrònic",
    messagePlaceholder: "Deixa'ns un missatge...",
    success: {
      title: "Èxit!",
      description: "Gràcies pel teu interès. Ens posarem en contacte aviat!"
    },
    error: {
      invalidName: {
        title: "Nom Invàlid",
        description: "Si us plau, introdueix un nom vàlid (2-50 caràcters, només lletres i espais)"
      },
      invalidEmail: {
        title: "Correu Electrònic Invàlid",
        description: "Si us plau, introdueix una adreça de correu electrònic vàlida"
      },
      generic: {
        title: "Error",
        description: "Alguna cosa ha anat malament. Si us plau, torna-ho a provar."
      }
    }
  },
  pt: {
    name: "Nome",
    email: "Email",
    message: "Mensagem (opcional)",
    cancel: "Cancelar",
    send: "Enviar",
    sending: "Enviando...",
    namePlaceholder: "Digite seu nome",
    emailPlaceholder: "Digite seu email",
    messagePlaceholder: "Deixe uma mensagem...",
    success: {
      title: "Sucesso!",
      description: "Obrigado pelo seu interesse. Entraremos em contato em breve!"
    },
    error: {
      invalidName: {
        title: "Nome Inválido",
        description: "Por favor, digite um nome válido (2-50 caracteres, apenas letras e espaços)"
      },
      invalidEmail: {
        title: "Email Inválido",
        description: "Por favor, digite um endereço de email válido"
      },
      generic: {
        title: "Erro",
        description: "Algo deu errado. Por favor, tente novamente."
      }
    }
  }
};
